<template>
    <div :class="['pt-table-row_cell', column.key]" :style="{ width: columnWidth }">
        <slot>{{ source[column.key] ?? '--' }}</slot>
    </div>
</template>

<script lang="ts">
export default {
    name: 'RowCell',
};
</script>

<script lang="ts" setup>
import type { Props as TableProps } from '../table.vue';

interface Props {
    source: any;
    column: TableProps['columns'][number];
    columnWidth?: string;
}
defineProps<Props>();
</script>

<style lang="scss">
.pt-table-row_cell {
    display: inline-block;
    vertical-align: middle;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: left;
    flex-grow: 0;
    flex-shrink: 0;
    padding-left: 24px;
    position: relative;
}
</style>
